var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppellate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.18 301.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:11px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.01,
    y: 83.91,
    width: 34.6,
    height: 122.28,
    rx: 17.3,
    ry: 17.3,
    transform: "translate(-73.48 112.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.26,
    y: -7.34,
    width: 34.6,
    height: 122.28,
    rx: 17.3,
    ry: 17.3,
    transform: "translate(17.77 150.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.71,
    y: 52.4,
    width: 94.45,
    height: 94.06,
    transform: "translate(-27.85 131.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.9,107.36h28.84v158.49c0,7.96-6.46,14.42-14.42,14.42h0c-7.96,0-14.42-6.46-14.42-14.42V107.36h0Z",
    transform: "translate(-66.95 225.99) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.6,263.11v-17.08c0-9.43,7.65-17.08,17.08-17.08h87.07c9.15,0,16.57,7.41,16.57,16.57v17.59s-120.73,0-120.73,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.61,
    y: 200,
    width: 32.7,
    height: 158.92,
    rx: 9.33,
    ry: 9.33,
    transform: "translate(364.42 194.5) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppellate);
export default __webpack_public_path__ + "static/media/appellate.1c8f93ba593101fa69931e47a09ffc99.svg";
export { ForwardRef as ReactComponent };